import { tns } from 'tiny-slider';

// homer main slider

document.addEventListener('DOMContentLoaded', () => {
  const sliders3 = document.querySelectorAll('.colSliderCount3');
  const sliders4 = document.querySelectorAll('.colSliderCount4');

  if (document.querySelectorAll('.pHome-slider__container').length) {
    const heroSlider = tns({
      container: '.pHome-slider__container',
      items: 1,
      slideBy: 'page',
      autoplay: homepage.slider.autoplay,
      autoplayTimeout: homepage.slider.delay,
      autoplayButtonOutput: false,
      speed: 500,
      controls: false,
      mouseDrag: false,
      nav: false,
    });

    heroSlider.events.on('transitionStart', (info, eventName) => {
      document.querySelector('#tns1-mw').style.height = info.slideItems[info.index].clientHeight + 'px';
    })
  }

  // col slider
  const colSliderBaseParams = {
    slideBy: '2',
    speed: 500,
    controls: true,
    controlsPosition: 'top',
    lazyload: true,
    lazyloadSelector: '.tns-lazy',
    mouseDrag: true,
    nav: false,
    loop: false,
    rewind: true,
    controlsText: ['<i class="far fa-arrow-left"></i>', '<i class="far fa-arrow-right"></i>'],
  };

  if (sliders3.length) {
    const colSlider3Params = colSliderBaseParams;
    colSlider3Params.responsive = {
      320: {
        items: 2,
        gutter: 10,
      },
      820: {
        items: 3,
        gutter: 30,
      },
    };

    sliders3.forEach((item) => {
      colSlider3Params.container = item;
      tns(colSlider3Params);
    });
  }

  if (sliders4.length) {
    const colSlider4Params = colSliderBaseParams;
    colSlider4Params.responsive = {
      320: {
        items: 2,
        gutter: 10,
      },
      820: {
        items: 3,
        gutter: 30,
      },
    };

    sliders4.forEach((item) => {
      colSlider4Params.container = item;
      tns(colSlider4Params);
    });
  }
});
